import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import Description from '@picsart/growth-rc/Description';
import Title from '@picsart/growth-rc/Title';

import CardsSectionItem from 'components/CardsSectionItem';
import LinkButton from 'redesignedComponents/molecules/CTA/LinkButton';
import useStyles from './styles';
import { CardsSectionProps } from './types';

const CardsSection = ({ title, description, cardsSectionItems, linkButton }: CardsSectionProps) => {
  const classes = useStyles();

  return (
    <HorizontalContainer className={classes.horizontalContainer}>
      {title && (
        <div className={classes.title} data-testid="cards-section-title">
          <Title {...title} />
        </div>
      )}
      {description && (
        <div className={classes.description} data-testid="cards-section-description">
          <Description {...description} />
        </div>
      )}
      <div className={classes.cards} data-pulse-section="cards-section">
        {cardsSectionItems.map(item => (
          <CardsSectionItem key={item.id} {...item} data-pulse-name={item.title} />
        ))}
      </div>
      {linkButton && (
        <div className={classes.cardsButton} data-pulse-section="cards-section-button">
          <LinkButton {...linkButton} />
        </div>
      )}
    </HorizontalContainer>
  );
};

export default CardsSection;
